import users from './users'
export default {
	users
}



// WEBPACK FOOTER //
// ./src/store/mp/user_center/index.js